import { useEffect, useRef, useState } from "react";
import { motion, useSpring, useTransform } from "framer-motion";
import { cn } from "../../lib/cn";

interface AnimatedNumberProps {
  value: number;
  format?: (n: number) => string;
  duration?: number;
  className?: string;
}

function AnimatedNumber({
  value,
  format = (n) => Math.round(n).toLocaleString(),
  duration = 0.6,
  className,
}: AnimatedNumberProps) {
  const spring = useSpring(value, {
    stiffness: 100,
    damping: 20,
    duration,
  });

  const display = useTransform(spring, (latest) => format(latest));
  const [text, setText] = useState(format(value));
  const prevRef = useRef(value);

  useEffect(() => {
    spring.set(value);
    prevRef.current = value;
  }, [value, spring]);

  useEffect(() => {
    const unsubscribe = display.on("change", (v) => setText(v));
    return unsubscribe;
  }, [display]);

  return (
    <motion.span
      className={cn("tabular-nums", className)}
      aria-label={format(value)}
    >
      {text}
    </motion.span>
  );
}

AnimatedNumber.displayName = "AnimatedNumber";

export { AnimatedNumber };
export type { AnimatedNumberProps };
